import { disableModalCloseBtn, setModalConfiguration, toggleModal } from "../../app/redux/actions/globalModalAction";
import { useAppDispatch } from "../../app/redux/hooks";
import { ModalConfig } from "../../app/redux/reducers/globalModalReducer";

export const useGlobalModal = () => {
    const dispatch = useAppDispatch()

    const handleOpenModal = () => dispatch(toggleModal(true))
    const handleCloseModal = () => dispatch(toggleModal(false))
    const handleEnableClose = () => dispatch(disableModalCloseBtn(false))
    const handleDisableClose = () => dispatch(disableModalCloseBtn(true))
    
    const handleSetConfig = (modalConfig: ModalConfig) => {
      dispatch(setModalConfiguration(modalConfig))
    }

    return {
        open: handleOpenModal,
        close: handleCloseModal,
        enableClose: handleEnableClose,
        disableClose: handleDisableClose,
        setConfig: handleSetConfig
    }
}